import svgIconClasses from "@mui/material/SvgIcon/svgIconClasses";
import breadcrumbsClasses from "@mui/material/Breadcrumbs/breadcrumbsClasses";
import { resolve } from "../../styles/utils/utils";
export const colorStates = (dt, variant) => {
    const textColor = resolve(dt.cta.outlined.color.text, variant);
    return {
        color: textColor.default,
        textDecorationColor: textColor.default,
        ".PixelIcon": {
            backgroundColor: textColor.default,
        },
        [`.${breadcrumbsClasses.root} &`]: {
            color: dt.color.onSurface.variant,
            textDecorationColor: dt.color.onSurface.variant,
            "&:visited, &:is(.Pxl-demo-pressed, [data-demostate=pressed])": {
                color: dt.color.onSurface.variant,
                textDecorationColor: dt.color.onSurface.variant,
                "&:hover, &:is(.Pxl-demo-hover, [data-demostate=hover])": {
                    color: textColor.hover,
                    textDecorationColor: textColor.hover,
                    ".PixelIcon": {
                        backgroundColor: textColor.hover,
                    },
                },
                "&:focus-visible, &:is(.Pxl-demo-focus, [data-demostate=focus])": {
                    color: textColor.focus,
                    textDecorationColor: textColor.focus,
                    ".PixelIcon": {
                        backgroundColor: textColor.focus,
                    },
                },
                "&:active, &:is(.Pxl-demo-active, [data-demostate=active])": {
                    color: textColor.active,
                    textDecorationColor: textColor.active,
                    ".PixelIcon": {
                        backgroundColor: textColor.active,
                    },
                },
            },
        },
        "&:hover, &:is(.Pxl-demo-hover, [data-demostate=hover])": {
            color: textColor.hover,
            textDecorationColor: textColor.hover,
            ".PixelIcon": {
                backgroundColor: textColor.hover,
            },
        },
        "&:focus-visible, &:is(.Pxl-demo-focus, [data-demostate=focus])": {
            color: textColor.focus,
            textDecorationColor: textColor.focus,
            ".PixelIcon": {
                backgroundColor: textColor.focus,
            },
        },
        "&:active, &:is(.Pxl-demo-active, [data-demostate=active])": {
            color: textColor.active,
            textDecorationColor: textColor.active,
            ".PixelIcon": {
                backgroundColor: textColor.active,
            },
        },
        "&:visited, &:is(.Pxl-demo-pressed, [data-demostate=pressed])": {
            color: textColor.pressed,
            textDecorationColor: textColor.pressed,
            ".PixelIcon": {
                backgroundColor: textColor.pressed,
            },
        },
    };
};
export const MuiLinkTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, colorStates(dt, ["primary"])), { [`.${svgIconClasses.root}[class]`]: {
                    transform: "translateY(0.125em)",
                    width: "1em",
                    height: "1em",
                } }),
        },
    };
};
